// Static data for prescriptions
export const prescriptions = {
  active: [
    {
      id: 1,
      medication: "Amoxicillin 250mg",
      dosage: "5ml every 8 hours",
      doctor: "Dr. Sarah Johnson",
      doctorSpecialty: "Pediatrician",
      date: "2024-01-10",
      expiry: "2024-02-10",
      quantity: "100ml",
      refills: 0,
      pharmacy: "Community Pharmacy",
      pharmacyAddress: "123 Health St, Johannesburg",
      instructions: "Take after meals. Complete full 7-day course.",
      sideEffects: "Nausea, diarrhea, rash",
      warnings: "Do not take if allergic to penicillin",
      status: "active",
      rxNumber: "RX-2024-00123",
      medicalAidCovered: true,
      daysSupply: 7,
    },
    {
      id: 2,
      medication: "Paracetamol 500mg",
      dosage: "1 tablet every 6 hours",
      doctor: "Dr. Michael Smith",
      doctorSpecialty: "General Practitioner",
      date: "2024-01-05",
      expiry: "2024-04-05",
      quantity: "20 tablets",
      refills: 2,
      pharmacy: "City Pharmacy",
      pharmacyAddress: "456 Main Rd, Sandton",
      instructions: "For fever and pain. Do not exceed 4 tablets in 24 hours.",
      sideEffects: "Rare - may cause liver damage if overdosed",
      warnings: "Consult doctor if symptoms persist beyond 3 days",
      status: "active",
      rxNumber: "RX-2024-00124",
      medicalAidCovered: true,
      daysSupply: 10,
    },
    {
      id: 3,
      medication: "Vitamin D3 1000IU",
      dosage: "1 capsule daily with food",
      doctor: "Dr. Lerato Molefe",
      doctorSpecialty: "Nutritionist",
      date: "2024-01-12",
      expiry: "2024-07-12",
      quantity: "90 capsules",
      refills: 5,
      pharmacy: "Wellness Pharmacy",
      pharmacyAddress: "789 Wellness Ave, Randburg",
      instructions: "Take with breakfast for better absorption",
      sideEffects: "None expected at recommended dosage",
      warnings: "Keep out of reach of children",
      status: "active",
      rxNumber: "RX-2024-00125",
      medicalAidCovered: false,
      daysSupply: 90,
    },
  ],
  expired: [
    {
      id: 4,
      medication: "Cough Syrup (Dextromethorphan)",
      dosage: "10ml every 12 hours",
      doctor: "Dr. Online Consultant",
      doctorSpecialty: "Telemedicine",
      date: "2024-11-01",
      expiry: "2024-12-01",
      quantity: "120ml",
      refills: 0,
      pharmacy: "Virtual Pharmacy",
      pharmacyAddress: "Online",
      instructions: "Shake well before use. Do not drive after taking.",
      sideEffects: "Drowsiness, dizziness",
      warnings: "Do not take with alcohol",
      status: "expired",
      rxNumber: "RX-2024-00126",
      medicalAidCovered: true,
      daysSupply: 12,
    },
  ],
  requested: [
    {
      id: 5,
      medication: "Vitamin D Drops 400IU",
      dosage: "0.5ml daily",
      doctor: "Dr. Sarah Johnson",
      doctorSpecialty: "Pediatrician",
      date: "2024-01-14",
      status: "pending",
      estimatedReady: "Tomorrow, 2 PM",
      pharmacy: "Community Pharmacy",
      requestId: "REQ-2024-001",
      refillFor: "RX-2024-00123",
    },
  ],
};
